export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.e963ef69.worker.js");
}
